module.exports = __webpack_public_path__ + "img/thumb_29.ba462bcc.jpg";